import { render, staticRenderFns } from "./estimateDetails.vue?vue&type=template&id=13227dd8&scoped=true&"
import script from "./estimateDetails.vue?vue&type=script&lang=js&"
export * from "./estimateDetails.vue?vue&type=script&lang=js&"
import style0 from "./estimateDetails.vue?vue&type=style&index=0&id=13227dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13227dd8",
  null
  
)

export default component.exports